module.exports = __webpack_public_path__ + "static/media/skip-dots.a789f2cc.svg";